module.exports = __webpack_public_path__ + "media/images/public-dashboard-alt-d0516442188fb3699c06ef22c33cfa70.jpg";